import { utils } from 'ethers';
import {computed, makeAutoObservable, observable} from 'mobx';
import { contractAddresses, tokenDecimals } from '../helpers/config/contracts.config';
import {removeTrailingZeros} from '../helpers/formatters';
import apiService from "../services/api/api.service";
import { IAccountBalance } from '../services/api/api.interfaces';


const convertUsdcBalanceToDecimal = (balance: string) => {
    return removeTrailingZeros(utils.formatUnits(balance, tokenDecimals.usdc));
}

class BalanceStore {
    latestBlock = 0;
    usdcTokenBalance = '0';
    usdcAvailableBalance = '0';

    get usdcAvailableBalanceDecimal() {
        return convertUsdcBalanceToDecimal(this.usdcAvailableBalance);
    }
    get usdcTokenBalanceDecimal() {
        return convertUsdcBalanceToDecimal(this.usdcTokenBalance);
    }

    constructor() {
        makeAutoObservable(this, {
            usdcAvailableBalance: observable,
            latestBlock: observable,
            usdcTokenBalance: observable,
            usdcAvailableBalanceDecimal: computed,
            usdcTokenBalanceDecimal: computed,
        });
    }

    public setUsdcAvailableBalance(newBalance: IAccountBalance) {
        this.usdcAvailableBalance = newBalance.availableBalance;
    }

    public resetUsdcAvailableBalance() {
        this.usdcAvailableBalance = '0';
    }

    public resetState() {
        this.usdcTokenBalance = '0';
        this.usdcAvailableBalance = '0';
    }

    setUsdcTokenBalanceDecimal(newBalance: string) {
        this.usdcTokenBalance = newBalance;
    }

    setLatestBlock(newBlock: number) {
        this.latestBlock = newBlock;
    }

    async fetchBalance(userAddress: string) {
        try {
            const balances = await apiService.accountsBalancesGet({user: userAddress});
            const usdcBalance = balances.find((a: IAccountBalance) => a.token.toLowerCase() ===  contractAddresses.base.usdc.toLowerCase())
            if (usdcBalance) {
                this.setUsdcAvailableBalance(usdcBalance)
            } else {
                this.resetUsdcAvailableBalance()
            }
        } catch (error) {
            console.error('Failed to fetch balances:', error);
        }
    }

    async fetchTokenBalance(usdcContract: any, address: string, blockNumber: number) {
        if (usdcContract && blockNumber - this.latestBlock > 1) {
            const balance = await usdcContract.read.balanceOf([address]);
            this.setUsdcTokenBalanceDecimal(balance.toString());
            this.setLatestBlock(blockNumber);
        }
    }
}

export const balanceStore = new BalanceStore();
